class PlpCollectionChips extends HTMLElement {
  connectedCallback() {
    this._view = this.dataset.view || '';
    this.addEventListener('click', this._onClick);
    window.addEventListener('popstate', this._onPopState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    window.removeEventListener('popstate', this._onPopState);
  }

  _getGrid() {
    const el = document.querySelector('.section-plpg[data-section-id]');
    return el || null;
  }

  _onClick = async (e) => {
    const chip = e.target.closest('[data-chip-handle]');
    if (!chip) return;

    const handle = chip.dataset.chipHandle;
    if (!handle) return;

    // When AJAX swap is disabled, let the native <a> navigate.
    if (this.dataset.collectionSwap !== 'true') return;

    const grid = this._getGrid();
    if (!grid) return;

    e.preventDefault();

    /* Active chip — update immediately for instant feedback. */
    this.querySelectorAll('[data-chip-handle]').forEach((c) => {
      const active = c === chip;
      c.classList.toggle('is-active', active);
      if (active) {
        c.setAttribute('aria-current', 'page');
      } else {
        c.removeAttribute('aria-current');
      }
    });

    grid.classList.add('is-loading');

    const sectionId = grid.dataset.sectionId;
    const params = new URLSearchParams({ sections: sectionId });
    if (this._view) params.set('view', this._view);

    try {
      const res = await fetch(`/collections/${handle}?${params}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const html = data[sectionId];
      if (!html) throw new Error('Section missing from response');

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.querySelector(`[data-section-id="${sectionId}"]`);
      if (newSection) {
        grid.replaceWith(newSection);
      }

      const newPath = `/collections/${handle}${this._view ? `?view=${encodeURIComponent(this._view)}` : ''}`;
      history.pushState({ plpCollection: handle }, '', newPath);

    } catch (err) {
      console.error('[plp-collection-hero] Swap failed, falling back to navigation', err);
      window.location.href = chip.href;
    }
  };

  /* On browser back/forward, reload so the page reflects the correct collection. */
  _onPopState = (e) => {
    if (e.state && 'plpCollection' in e.state) {
      window.location.reload();
    }
  };
}

if (!customElements.get('plp-collection-chips')) {
  customElements.define('plp-collection-chips', PlpCollectionChips);
}
